import { createVNode as a, mergeProps as e } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NotificationFilledStandard.js";
import d from "../components/PfIcon.js";
const t = (i, o) => {
  const r = {
    ...i,
    ...o.attrs
  };
  return a(d, e(r, {
    icon: n
  }), null);
};
t.displayName = "NotificationFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
